const list = {
    searchList: [
        // {
        //     showField: "开始时间",
        //     entityField: "start",
        //     isShow: 1,
        //     fieldType: "date",
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     fieldWeight: 120,
        // },
        // {
        //     showField: "结束时间",
        //     entityField: "end",
        //     isShow: 1,
        //     fieldType: "date",
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     fieldWeight: 120,
        // },
        // {
        //     showField: "销售单位",
        //     entityField: "cmName",
        //     isShow: 1,
        //     fieldType: "search",
        //     searchId: 3391151360249856,
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     setField: "cmName,cmId",
        //     fieldWeight: 120,
        // },
        // {
        //     showField: "业务员",
        //     entityField: "salesName",
        //     isShow: 1,
        //     fieldType: "search",
        //     searchId: 4444770562019328,
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     setField: "salesName,salesId",
        //     fieldWeight: 120,
        // },
        // {
        //     showField: "货主",
        //     entityField: "coName",
        //     isShow: 1,
        //     fieldType: "search",
        //     searchId: 4414428383875072,
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     setField: "coName,coId",
        //     fieldWeight: 120,
        // },
        // {
        //     showField: "数据来源",
        //     entityField: "orderSource",
        //     isShow: 1,
        //     fieldType: "string",
        //     searchId: null,
        //     formatterContent: null,
        //     isRift: null,
        //     riftField: null,
        //     setField: null,
        //     fieldWeight: 120,
        // },
        // {
        //     showField: "订单类型",
        //     entityField: "businessType",
        //     isShow: 1,
        //     fieldType: "select",
        //     searchId: null,
        //     formatterContent: [
        //         {
        //             key: "销售出库",
        //             value: '销售出库',
        //         },
        //         {
        //             key: "销售退补",
        //             value: "销售退补",
        //         },
        //         {
        //             key: "销售退货",
        //             value: "销售退货",
        //         },
        //     ],
        //     isRift: null,
        //     riftField: null,
        //     setField: null,
        //     fieldWeight: 120,
        // },
    ],
}
export default list
